module.exports = require("@seddi/three/addons/loaders/HDRLoader.js");